export default __webpack_public_path__ + "static/media/iluustrations.106a8965.png";